class ReadingProgress {
    constructor() {
        this.progressBar = null;
        this.articleContent = document.querySelector('.article-content-main');
        this.throttleDelay = 100; // ms
        this.throttleTimer = null;

        if (this.articleContent) {
            this.init();
        }
    }

    init() {
        this.createProgressBar();
        this.attachScrollListener();
        this.updateProgress(); // Initial calculation
    }

    createProgressBar() {
        // Create progress bar container
        const container = document.createElement('div');
        container.className = 'reading-progress-bar';

        // Create progress fill
        const fill = document.createElement('div');
        fill.className = 'reading-progress-bar__fill';

        container.appendChild(fill);
        document.body.prepend(container);

        this.progressBar = fill;
    }

    attachScrollListener() {
        window.addEventListener('scroll', () => {
            if (this.throttleTimer) {
                return;
            }

            this.throttleTimer = setTimeout(() => {
                this.updateProgress();
                this.throttleTimer = null;
            }, this.throttleDelay);
        }, { passive: true });
    }

    updateProgress() {
        // Calculate scroll progress
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        // Calculate percentage
        const scrollableDistance = documentHeight - windowHeight;
        const scrollPercentage = (scrollTop / scrollableDistance) * 100;

        // Clamp between 0 and 100
        const progress = Math.min(Math.max(scrollPercentage, 0), 100);

        // Update progress bar width
        if (this.progressBar) {
            this.progressBar.style.width = `${progress}%`;
        }
    }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new ReadingProgress();
    });
} else {
    new ReadingProgress();
}